export class SettingsPath {
  public static readonly SETTINGS_ENDPOINT = '.settings';
}
